// hooks/use-query-string-object.ts
import {useLocation} from 'react-router'
import useSearchParams from '../hooks/use-search-params'

/**
 * Hook to access the current location object (like the old locationSelector)
 */
export function useCurrentLocation() {
    return useLocation()
}

/**
 * Hook to parse the query string into a plain object (like the old )
 */
export function useQueryStringObject<T extends Record<string, string>>() {
    const [searchParams] = useSearchParams<T>()
    return searchParams
}
